<template>
		<!-- ---------- -->

		<div class="footer_warp">

				<img class="footer_center_img" src="../assets/img/footer/footerbanner.png" alt="" />
			<div class="footer_cont">
				<!-- 上部 -->

				<div class="footer_cont_l">
					<!--上部 左 -->
					<div class="footer_cont_l_div">
						<div class="footer_cont_l_div_item">
							<p class="footer_cont_l_title">产品</p>
							<ul class="footer_cont_l_ul">
								<li
									v-for="(item, index) in arrList"
									:key="index"
									@click="toGuid(item.url, item.id)"
								>
									{{ item.title }}
								</li>

								<!-- <li>解决方案</li> -->
							</ul>
						</div>
						<div class="footer_cont_l_div_item">
							<p class="footer_cont_l_title">解决方案</p>
							<ul class="footer_cont_l_ul">
								<li
									v-for="(item, index) in arrList2"
									:key="index"
									@click="toPages(item.url)"
								>
									{{ item.title }}
								</li>
							</ul>
						</div>
						<div class="footer_cont_l_div_item">
							<p class="footer_cont_l_title">联系我们</p>
							<ul class="footer_cont_l_ul">
								<li
									v-for="(item, index) in arrList3"
									:key="index"
									@click="toNews(item.url)"
								>
									{{ item.title }}
								</li>
							</ul>
						</div>
						<!--<div class="footer_cont_l_div_item2">-->
							<!--<p class="footer_cont_l_title">XXXX</p>-->
							<!--<ul class="footer_cont_l_ul">-->
								<!--<router-link to="zhaopinxinxi0"><li>招聘信息</li></router-link>-->
							<!--</ul>-->
						<!--</div>-->
					</div>
				</div>
				<!-- top 中 -->
				<!--<div class="footer_cont_c">-->
					<!--&lt;!&ndash;<div class="navWrap_center_img" >&ndash;&gt;-->
						<!--&lt;!&ndash;<img src="../assets/img/.png" alt="" />&ndash;&gt;-->
					<!--&lt;!&ndash;</div>&ndash;&gt;-->
					<!--&lt;!&ndash;<div class="logos">&ndash;&gt;-->
						<!--&lt;!&ndash;<div class="company_name">北京弘易信泰</div>&ndash;&gt;-->
						<!--&lt;!&ndash;<div class="header-title company_name">hongyixintai.com</div>&ndash;&gt;-->
					<!--&lt;!&ndash;</div>&ndash;&gt;-->
						<!--<img class="logos" src="../assets/logonew.png" alt="" />-->
					<!--&lt;!&ndash;<div class="logo_content">&ndash;&gt;-->
						<!--&lt;!&ndash;<div class="company_name">北京弘易信泰</div>&ndash;&gt;-->
						<!--&lt;!&ndash;<div class="company_name">hongyixintai.com</div>&ndash;&gt;-->
					<!--&lt;!&ndash;</div>&ndash;&gt;-->
					<!--<div>-->
						<!--<p class="address">-->
							<!--公司总部地址：北京市朝阳区<br />-->
							<!--邮箱：lujun@hongyixintai.com-->
						<!--</p>-->
					<!--</div>-->
				<!--</div>-->
				<!-- top 右 -->
				<!--<div class="footer_cont_r">-->
					<!--<div>-->
						<!--<div class="footer_cont_r_border">-->
							<!--<img src="../assets/img/" alt="" />-->
						<!--</div>-->
						<!--<p>关注微信公众号</p>-->
					<!--</div>-->
				<!--</div>-->
			</div>
			<!-- 下部 -->
			<div class="footer_warp_btm">
				<p>
					Copyright
					©&ensp;&ensp;北京弘易信泰科技发展有限公司&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;<a href="https://beian.miit.gov.cn/" target="_blank" >京ICP备2023037340号</a>
				</p>
			</div>
		</div>

		<!-- --------- -->
</template>

<script>
export default {
	name: "Footer",
	data() {
		return {
			arrList: [
				{
					title: "智能数据",
					url: "/intdata",
					id: "intdata",
				},
				{
					title: "数据治理",
					url: "/datagov",
					id: "datagov",
				},
				{
					title: "专家系统",
					url: "/jituangaikuo",
					id: "history",
				},
				{
					title: "智慧决策",
					url: "/jituangaikuo",
					id: "history",
				},
			],
			arrList2: [
				{
					title: "政务服务",
					url: "/govSolution",
				},
				{
					title: "教育行业",
					url: "/eduSolution",
				},
				{
					title: "金融行业",
					url: "/finSolution",
				},
				{
					title: "互联网+",
					url: "/netSolution",
				},

			],
			arrList3: [
				{
					title: "企业邮箱:lujun@hongyisoftware.cn",
					// url: "/xinwen",
				},
				// {
				// 	title: "电话:",
					// url: "/xinwen/MediaCoverage",
				// },
				// {
				// 	title: "公众号/企业微信",
				// 	// url: "/xinwen/TradeNews",
				// },
			],
		};
	},

	mounted() {
		let _this = this;
		_this.$nextTick(function () {
			window.addEventListener("scroll", _this.handleScroll);
		});
	},

	methods: {
		// 锚点跳转
		toGuid(path, id) {
			localStorage.setItem("toId", id);
			this.$router.push(path);
			//查找存储的锚点id
			let Id = localStorage.getItem("toId");
			let toElement = document.getElementById(Id);
			//锚点存在跳转
			if (Id) {
				toElement.scrollIntoView();
				localStorage.setItem("toId", "");
			}
		},

		toPages(url) {
			this.$router.push(url);
		},
		toNews(url) {
			this.$router.push(url);
		},
	},
};
</script>
<style scoped>
@charset "utf-8";
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
	margin: 0;
	padding: 0;
}
/*去内外边距*/
html,
body {
	font-family: "微软雅黑", "宋体", Arail, Tabhoma;
	text-align: left;
}
/*字体 文本居左*/
ul {
	list-style: none;
}
/*去ul li 小点*/
img {
	border: 0 none;
}
/*img IE6 兼容问题*/
input,
select,
textarea {
	outline: 0;
}
/*去除点击蓝框*/
textarea {
	resize: none;
	overflow: auto;
}
/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
	border-collapse: collapse;
	border-spacing: 0;
}
/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
	font-weight: normal;
	font-style: normal;
}
/*特殊文字粗细 样式显示正常*/
a {
	text-decoration: none;
}
/*a标签去下划线*/
.clearfix:after {
	clear: both;
	content: "";
	display: block;
	height: 0;
}
/*清浮动*/
a {
	color: #000000;
}
/*==========================Reset_End===========================*/

.footer_warp {
	/*width: 100%;*/
	height: auto;
	position: absolute;
	background: #17213d;
	margin-top: 30px ;
	/*background-position: right bottom, left top;*/
}
.footer_center_img{
	display: flex;
	justify-content: space-between;
}
@media screen and (max-device-width: 1900px) {
	.footer_center_img {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.footer_center_img {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.footer_center_img {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.footer_center_img {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.footer_center_img {
		height: auto;
		width: 2560px;
	}
}
.footer_cont {
	/*width: 1200px;*/
	margin: 0 auto;
	display: flex;
}
.footer_cont_l {
	font-size: 16px;
	font-weight: 500;
	color: #dddddd;
	line-height: 22px;
	padding-top: 88px;
	padding-left: 128px;
}
.footer_cont_l_title {
	font-size: 25px;
	font-family: AlibabaPuHuiTi-3-55-Regular;
	font-weight: 500;
	color: #dddddd;
	line-height: 25px;
	width: 100px;
}
.footer_cont_l_ul {
	margin-top: 36px;
}
.footer_cont_l_ul li {
	font-size: 16px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 400;
	color: #dddddd;
	margin-top: 10px;
	cursor: pointer;
}
.footer_cont_l_div {
	display: flex;
}
.footer_cont_l_div_item {
	margin-right: 72px;
}
.footer_cont_c {
	margin-top: 70px;
	margin-left: 80px;
}
.logo_pic {
	float:left;
	width: 40%;
	font-size: 16px;
	font-family: AlibabaPuHuiTi-3-55-Regular;
	font-weight: 400;
	line-height: 32px;
	margin-top: 42px;
}
.logo_content {
	float: right;
	width: 60%;
	font-size: 16px;
	font-family: "PingFangSC-Regular", "PingFang SC";
	font-weight: 400;
	color: #ffffff;
	line-height: 32px;
	margin-top: 42px;
}.logos{
	float: left;
	width: 200px;
	height: auto;
	display:flex;
	align-items: center;
 }
.address {
	width: 467px;
	font-size: 16px;
	font-family: "PingFangSC-Regular", "PingFang SC";
	font-weight: 400;
	color: #ffffff;
	line-height: 32px;
	margin-top: 42px;
}
.footer_cont_r {
	margin-top: 88px;
	margin-left: 128px;
}
.footer_cont_r p {
	text-align: center;
	font-size: 14px;
	font-family: AlibabaPuHuiTi-3-55-Regular;
	font-weight: 400;
	color: #ffffff;
	line-height: 20px;
	margin-top: 17px;
}
.footer_cont_r_border {
	width: 111px;
	height: 109px;
	border: 1px solid #979797;
}
.footer_cont_r_border img {
	width: 95px;
	height: 95px;
	margin: 7px 8px;
}
.footer_warp_btm {
	width: 1920px;
	margin: 0 auto;
	height: 65px;
	margin-top: 56px;
	border-top: 1px solid #444444;
	text-align: center;
}
@media screen and (max-device-width: 1900px) {
	.footer_warp_btm {
		width: 1440px;
		margin: 0 auto;
		height: 65px;
		margin-top: 56px;
		border-top: 1px solid #444444;
		text-align: center;
	}
}
@media screen and (min-device-width: 1950px) {
	.footer_warp_btm {
		width: 2560px;
		margin: 0 auto;
		height: 65px;
		margin-top: 56px;
		border-top: 1px solid #444444;
		text-align: center;
	}
}
.footer_warp_btm p {
	font-size: 12px;
	font-weight: 400;
	color: #a3a3a3;
	line-height: 48px;
}
.footer_warp_btm a {
	font-size: 12px;
	font-weight: 400;
	color: #a3a3a3;
	line-height: 48px;
}
</style>
